import * as React from "react";

const CalenderIcon = (props) => (
  <svg
    // width={30}
    // height={30}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M25.607 3.109h-2.605v-1.36a.906.906 0 0 0-1.813 0v1.36H8.502v-1.36a.906.906 0 1 0-1.813 0v1.36H4.084A3.742 3.742 0 0 0 .346 6.847v19.258a3.742 3.742 0 0 0 3.738 3.738h21.523a3.742 3.742 0 0 0 3.739-3.738V6.847a3.743 3.743 0 0 0-3.739-3.738ZM4.084 4.92h2.605v.906a.906.906 0 0 0 1.813 0v-.906h12.687v.906a.906.906 0 1 0 1.813 0v-.906h2.605c1.062 0 1.926.864 1.926 1.926v2.152H2.158V6.847c0-1.062.864-1.926 1.926-1.926Zm21.523 23.11H4.084a1.928 1.928 0 0 1-1.926-1.926V10.812h25.375v15.293a1.928 1.928 0 0 1-1.926 1.925Z"
      fill="currentColor"
    />
  </svg>
);

export default CalenderIcon;
